<mat-slide-toggle [checked]="isChecked()" [disabled]="disabled()" (change)="updateValue($event)">{{label()}}</mat-slide-toggle>